const IDLE_RELOAD_OPT_OUT_KEY = 'fg.session.idleReloadOptOut';

/** User chose not to be subject to automatic full-page reload for this tab (sessionStorage). */
export function getIdleReloadOptOut(): boolean {
  try {
    return sessionStorage.getItem(IDLE_RELOAD_OPT_OUT_KEY) === '1';
  } catch {
    return false;
  }
}

export function setIdleReloadOptOut(enabled: boolean): void {
  try {
    if (enabled) {
      sessionStorage.setItem(IDLE_RELOAD_OPT_OUT_KEY, '1');
    } else {
      sessionStorage.removeItem(IDLE_RELOAD_OPT_OUT_KEY);
    }
  } catch {
    // Storage may be unavailable (private mode, disabled).
  }
}
